class APIClient {
  constructor(baseUrl) {
    this.baseUrl = baseUrl || '';
  }

  withBaseUrl(baseUrl) {
    this.baseUrl = baseUrl;
    return this;
  }

  async request(url, method, data) {
    const requestOptions = {
      method: method,
      body: data ? JSON.stringify(data) : undefined
    };

    const response = await fetch(`${this.baseUrl}${url}`, {
      ...requestOptions,
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return response.json();
  }

  async get(url) {
    return this.request(url, 'GET');
  }

  async post(url, data) {
    return this.request(url, 'POST', data);
  }
}

export const apiClient = new APIClient();
